import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import SearchPage from './pages/SearchPage';
import AIChatPage from './pages/AIChatPage';
import IssueDetailPage from './pages/IssueDetailPage';
import PageDetailPage from './pages/PageDetailPage';
import IssuePageRedirect from './pages/IssuePageRedirect';
import PhotoGalleryPage from './pages/PhotoGalleryPage';
import AdminUploadPage from './pages/AdminUploadPage';
import AdminTagsPage from './pages/AdminTagsPage';
import AdminTagPagesPage from './pages/AdminTagPagesPage';
import AdminSettingsPage from './pages/AdminSettingsPage';
import LoginPage from './pages/LoginPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import ShareLinkLoginPage from './pages/ShareLinkLoginPage';
import NotFoundPage from './pages/NotFoundPage';
import { authAPI } from './services/api';

const PORTAL_URL = 'https://portal.lionsclubs.org.hk';

function ProtectedRoute({ children }) {
  const location = useLocation();
  if (!authAPI.isAuthenticated()) {
    // Redirect unauthenticated users to the membership portal
    window.location.replace(PORTAL_URL);
    return null;
  }
  return children;
}

function App() {
  return (
    <Routes>
      {/* Admin local login */}
      <Route path="/login" element={<LoginPage />} />
      {/* SSO callback from membership portal */}
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      {/* Shareable login link (logs in as a normal user) */}
      <Route path="/auth/share-link" element={<ShareLinkLoginPage />} />
      <Route path="*" element={
        <ProtectedRoute>
          <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Header />
            <Box component="main" sx={{ flexGrow: 1 }}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/search" element={<SearchPage />} />
                <Route path="/ai" element={<AIChatPage />} />
                <Route path="/issues/:id" element={<IssueDetailPage />} />
                <Route path="/issues/:issueId/pages/:pageNumber" element={<IssuePageRedirect />} />
                <Route path="/pages/:id" element={<PageDetailPage />} />
                <Route path="/photos" element={<PhotoGalleryPage />} />
                <Route path="/upload" element={<AdminUploadPage />} />
                <Route path="/admin/tags" element={<AdminTagsPage />} />
                <Route path="/admin/tags/:tagType/:tagId/pages" element={<AdminTagPagesPage />} />
                <Route path="/admin/settings" element={<AdminSettingsPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Box>
            <Footer />
          </Box>
        </ProtectedRoute>
      } />
    </Routes>
  );
}

export default App;
